import _inject from "@stylexjs/stylex/lib/stylex-inject";
import React from 'react';
import FeatherIcon from "../ui/feather-icon/FeatherIcon";
import * as stylex from '@stylexjs/stylex';
import PropTypes from "prop-types";
export default function PagerButton(props) {
  return /*#__PURE__*/React.createElement("div", stylex.props(ui.base, !props.active && ui.disabled, props.isFirst && ui.first, props.isLast && ui.last), /*#__PURE__*/React.createElement(FeatherIcon, {
    style: {
      fontSize: '18px',
      cursor: props.active ? 'pointer' : 'not-allowed',
      color: props.active ? 'var(--shade-80)' : 'var(--shade-10)'
    },
    onClick: function onClick() {
      if (props.active) {
        var _props$__click;
        (_props$__click = props.__click) === null || _props$__click === void 0 || _props$__click.call(props);
      }
    },
    icon: props.icon
  }));
}
_inject(".ev1ypdohk{cursor:pointer}", 3000);
_inject(".ev1h2kqdt{transition:background-color .2s}", 2000);
_inject(".ev1470adl{padding:0 2px}", 1000);
_inject(".ev1qx5ct2{height:20px}", 4000);
_inject(".evji57aj{background-color:var(--shade-10)}", 3000);
_inject(".ev6nv2ps:hover{background-color:var(--shade-20)}", 3130);
_inject(".ev12qy6l{border-top-left-radius:var(--roundness)}", 4000);
_inject(".ev36ibnl{border-bottom-left-radius:var(--roundness)}", 4000);
_inject(".evor0oh0{border-top-right-radius:var(--roundness)}", 4000);
_inject(".evzap5uf{border-bottom-right-radius:var(--roundness)}", 4000);
_inject(".ev3dtjww:hover{background-color:var(--shade-10)}", 3130);
var ui = {
  base: {
    "PagerButton__ui.base": "PagerButton__ui.base",
    cursor: "ev1ypdohk",
    transition: "ev1h2kqdt",
    transitionBehavior: null,
    transitionDelay: null,
    transitionDuration: null,
    transitionProperty: null,
    transitionTimingFunction: null,
    padding: "ev1470adl",
    paddingInline: null,
    paddingStart: null,
    paddingLeft: null,
    paddingEnd: null,
    paddingRight: null,
    paddingBlock: null,
    paddingTop: null,
    paddingBottom: null,
    height: "ev1qx5ct2",
    backgroundColor: "evji57aj ev6nv2ps",
    $$css: true
  },
  first: {
    "PagerButton__ui.first": "PagerButton__ui.first",
    borderTopLeftRadius: "ev12qy6l",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderBottomLeftRadius: "ev36ibnl",
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    $$css: true
  },
  last: {
    "PagerButton__ui.last": "PagerButton__ui.last",
    borderTopRightRadius: "evor0oh0",
    borderStartStartRadius: null,
    borderStartEndRadius: null,
    borderBottomRightRadius: "evzap5uf",
    borderEndStartRadius: null,
    borderEndEndRadius: null,
    $$css: true
  },
  disabled: {
    "PagerButton__ui.disabled": "PagerButton__ui.disabled",
    backgroundColor: "evji57aj ev3dtjww",
    $$css: true
  }
};
PagerButton.propTypes = {
  isFirst: PropTypes.bool,
  isLast: PropTypes.bool
};